import React from 'react';

interface CheckboxComponentProps {
  label: string;
  name: string;
  value: string | number;
  className?: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  pixels?: string;
  id?: string;
  disabled?: boolean;
}

const CheckboxComponent: React.FC<CheckboxComponentProps> = ({
  label,
  name,
  value,
  className = '',
  checked,
  onChange,
  pixels,
  id,
  disabled = false,
}) => {
  const cardClass = checked ? 'checkbox-card checked' : 'checkbox-card';
  const inputId = pixels ? id : `${name}-${value}`;
  const labelFor = pixels ? id : `${name}-${value}`;

  return (
    <div className={`checkbox-container ${className}`}>
      <div>
        <input
          type="checkbox"
          name={name}
          id={inputId}
          checked={checked}
          onChange={onChange}
          value={value}
          className="checkbox-card-input"
          disabled={disabled}
        />
        <label
          className={`checkbox-card-label ${cardClass}`}
          htmlFor={labelFor}
        >
          {label}
        </label>
      </div>
      {pixels && <div className="checkbox-pixels">{pixels}</div>}
    </div>
  );
};

export default CheckboxComponent;